import AssignmentPanel, { AssignmentPanelProps as Props } from './AssignmentPanel';

export type AssignmentPanelProps = Props;
export default AssignmentPanel;
